// extracted by mini-css-extract-plugin
export default {"color":"o5QJmeUOdzaNqmRbre7h","container":"jXC1SOsKt28ngLjv3ymD"};